import React from "react";
import ConfigurationService from "../../Services/Configuration.service";
const cache = {};
/**
 * This is guaranteed to return null at first until the configuration is loaded in.
 */
const useConfiguration = (key) => {
    const [config, setConfig] = React.useState(null);
    React.useEffect(() => {
        if (cache[key] == null) {
            cache[key] = ConfigurationService.getConfiguration(key);
        }
        cache[key].then((val) => {
            setConfig(val);
        });
    }, [key]);
    return config;
};
export default useConfiguration;
/**
 * If the configuration cannot be parsed as a number, this will always return null.  Our main objective with this
 * is to keep things simple and not have them blow up.
 */
export const useConfigurationAsNumber = (key) => {
    const config = useConfiguration(key);
    if (config == null) {
        return config;
    }
    try {
        return parseInt(config, 10);
    }
    catch (e) {
        console.error(`Config ${key} with value ${config} could not be parsed into a number`, e);
        return null;
    }
};
